<script lang="ts">
	import { TeamCardSingle, TeamCardDouble, SectionHeader } from "#lib/web-ui/primitives/index.js";
	import TeamBase from "./team-base.svelte";
	import type { TeamBaseProps } from "./team.types";

	let { featuredLabel = "Leadership", ...baseProps }: TeamBaseProps & { featuredLabel?: string } =
		$props();
</script>

<TeamBase {...baseProps}>
	{#snippet children({ label, title, subtitle, members })}
		<SectionHeader {label} {title} {subtitle} />

		{#if members.length > 0}
			{@const [featured, ...rest] = members}

			<TeamCardDouble {...featured} label={featuredLabel} />

			{#if rest.length > 0}
				<div class="mt-8 grid grid-cols-1 gap-8 md:grid-cols-2">
					{#each rest as member (member)}
						<TeamCardSingle {...member} />
					{/each}
				</div>
			{/if}
		{/if}
	{/snippet}
</TeamBase>
